import React, { useState, useEffect, useRef, memo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { Chips } from 'primereact/chips';
import axios from 'axios';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import DrawPrescription from './DrawPrescription';
import CreamsQuoter from './CreamsQuoter';
import useFormikHelpers from '../hooks/useFormikHelpers';
//import useAppRoot from '../hooks/useAppRoot';
import InputRut from '../components/InputRut';
import useRut from '../hooks/useRut';
import './DiagnosticProduct.scss';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import AddConcentrationModal from './addConcentration';

const NO_QUOTATION = 'SIN COTIZACION';
var FLAVORS = ['Carne', 'Salmón', 'Frutilla', 'Sin sabor'];

const DiagnosticProduct = ({ product, quotation, validating, onDataChange, productsLen }) => {
    const [products, setProducts] = useState([]);
    const [concentrations, setConcentrations] = useState([]);
    const [volumes, setVolumes] = useState([]);
    //const appRoot = useAppRoot();
    const [searchingDni, setSearchingDni] = useState(false);
    const { validate: validateRut } = useRut();
    const toast = useRef(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fromProduct, setFromProduct] = useState(false);

    const handleOpenModal = () => {
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        loadProducts();
        setIsModalVisible(false);
    };

    addLocale('es', {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar',
    });

    /* Cargar los datos iniciales */
    useEffect(() => {
        axios.get('/api/products').then(async (response) => {
            const productsList = [{ codigo_producto: NO_QUOTATION, producto: '-- NO COTIZAR --' }, ...response.data];
            setProducts(productsList);

            if (product.codigo_producto) {
                const selectedProduct = productsList.find((element) => element.codigo_producto === product.codigo_producto);
                formik.setFieldValue('selectedProduct', selectedProduct);

                const concentrations = await loadConcentrations(product.codigo_producto);
                const selectedConcentration = concentrations.find((element) => element.codigo_concentracion === product.codigo_concentracion);
                formik.setFieldValue('selectedConcentration', selectedConcentration);

                const volumes = await loadVolumes(product.codigo_producto, selectedConcentration.codigo_concentracion);
                const selectedVolume = volumes.find((element) => element.id === product.id_concentracion);
                formik.setFieldValue('selectedVolume', selectedVolume);

                if (product.codigo_producto == 'THC - CBD Cartridge') {
                    FLAVORS = ['Sin sabor', 'OG, Indica', 'Amnesia, Sativa'];
                } else {
                    FLAVORS = ['Sin sabor', 'Carne', 'Salmón', 'Frutilla'];
                }
            }
        });
    }, []);

    const loadProducts = async () => {
        axios.get('/api/products').then(async (response) => {
            const productsList = [{ codigo_producto: NO_QUOTATION, producto: '-- NO COTIZAR --' }, ...response.data];
            setProducts(productsList);
        });
    };

    const getConcentrations = async (productCode) => {
        const response = await axios.get('/api/products/' + encodeURIComponent(productCode) + '/concentrations');
        return response.data.map((product) => {
            return {
                codigo_producto: product.codigo_producto,
                codigo_concentracion: product.codigo_concentracion,
                label: product.concentracion + ' (' + product.con_unidad + ')',
            };
        });
    };

    const getVolumes = async (productCode, concentrationCode) => {
        const response = await axios.get('/api/products/' + encodeURIComponent(productCode) + '/' + encodeURIComponent(concentrationCode) + '/volumes');
        return response.data.map((product) => {
            return {
                id: product.id,
                precio: product.precio,
                label: product.tamano + ' ' + product.tam_unidad,
            };
        });
    };

    const loadConcentrations = async (productCode) => {
        const concentrations = await getConcentrations(productCode);
        setConcentrations(concentrations);
        return concentrations;
    };

    const loadVolumes = async (product, concentration) => {
        const volumes = await getVolumes(product, concentration);
        setVolumes(volumes);
        return volumes;
    };

    const onProductChange = (e) => {
        formik.setFieldValue('selectedConcentration', undefined, false);
        formik.setFieldValue('selectedVolume', undefined, false);
        formik.setFieldValue('selectedProduct', e.value);

        if (e.value.producto == 'THC / CBD Cartridge') {
            FLAVORS = ['Sin sabor', 'OG, Indica', 'Amnesia, Sativa'];
        } else {
            FLAVORS = ['Sin sabor', 'Carne', 'Salmón', 'Frutilla'];
        }

        if (![NO_QUOTATION, 'CREMA'].includes(e.value.codigo_producto)) {
            loadConcentrations(e.value.codigo_producto);
        }
    };

    const onConcentrationChange = (e) => {
        formik.setFieldValue('selectedVolume', undefined, false);
        formik.setFieldValue('selectedConcentration', e.value);
        loadVolumes(e.value.codigo_producto, e.value.codigo_concentracion);
    };

    const onVolumeChange = (e) => {
        formik.setFieldValue('selectedVolume', e.value);
    };

    const onFlavorChange = (e) => {
        formik.setFieldValue('flavor', e.value);
    };

    const onQuantityChange = (e) => {
        formik.setFieldValue('quantity', e.value);
    };

    const onMedicalCheckDateChange = (e) => {
        formik.setFieldValue('medicalCheckDate', e.value);
    };

    const onRenovationDateChange = (e) => {
        formik.setFieldValue('renovationDate', e.value);
    };

    const onExpirationDateChange = (e) => {
        formik.setFieldValue('expirationDate', e.value);
    };

    const onDiscountPercentageChange = (e) => {
        formik.setFieldValue('discountPercentage', parseInt(e.value));
    };

    // const onDicc

    const onPriceBeforeDiscountChange = (e) => {
        formik.setFieldValue('priceBeforeDiscount', e.value);
    };

    const onTicketNumbersChange = (e) => {
        formik.setFieldValue('ticketNumbers', e.value);
        // formik.setFieldValue('random', Math.random())
    };

    const onDniChange = (val) => {
        formik.setFieldValue('dni', val);
    };

    const onFullNameChange = (e) => {
        formik.setFieldValue('fullName', e.target.value);
    };

    const calculateDiscountAndPrice = () => {
        const discount1 = Math.round((formik.values.selectedVolume ? formik.values.selectedVolume.precio : 0) * (formik.values.discountPercentage / 100));
        const discount2 = Math.floor(discount1 / 10) * 10 * formik.values.quantity;

        formik.setFieldValue('discountValue', discount2, false);
        formik.setFieldValue('totalPrice', formik.values.priceBeforeDiscount - discount2);
    };

    const initialValues = {
        id: product.id_registro_concentracion,
        selectedProduct: undefined,
        selectedConcentration: undefined,
        selectedVolume: undefined,
        flavor: product.sabor,
        priceBeforeDiscount: 0,
        quantity: product.cantidad || 1,
        medicalCheckDate: new Date(product.fecha_control_medico + 'T00:00:00'),
        renovationDate: new Date(product.fecha_renovacion + 'T00:00:00'),
        expirationDate: new Date(product.fecha_expiracion + 'T00:00:00'),
        discountPercentage: product.porcentaje_descuento || 0,
        discountValue: product.descuento || 0,
        totalPrice: undefined,
        ticketNumbers: product.numero_boletas ? product.numero_boletas.split(',') : [],
        random: Math.random(),
        dni: product.rut ? product.rut : quotation.rut_paciente,
        fullName: product.nombre || quotation.nombre_paciente || '',
    };

    const validateForm = (data) => {
        let errors = {};

        if (!data.selectedProduct) {
            errors.selectedProduct = 'Por favor selecciona un producto';
        }

        if (!data.dni) {
            errors.dni = 'Por favor ingresar rut del titular';
        }

        if (data.dni && !validateRut(data.dni)) {
            errors.dni = 'El rut no es válido';
        }

        if (!data.fullName) {
            errors.fullName = 'Por favor ingresar nombre del titular';
        }

        if (data.selectedProduct && data.selectedProduct.codigo_producto === NO_QUOTATION) {
            return {};
        }

        if (data.selectedProduct && data.selectedProduct.codigo_producto === 'CREMA') {
            if (quoterFormik.current && quoterFormik.current.errors) {
                errors = { ...errors, ...quoterFormik.current.errors };
            }
        } else {
            if (!data.flavor) {
                errors.flavor = 'Por favor selecciona un sabor';
            }
            if (!data.selectedConcentration) {
                errors.selectedConcentration = 'Por favor selecciona una concentración';
            }
            if (!data.selectedVolume) {
                errors.selectedVolume = 'Por favor selecciona un volumen';
            }
            if (!data.quantity) {
                errors.quantity = 'Cantidad no es válida';
            }
            if (!data.priceBeforeDiscount) {
                errors.priceBeforeDiscount = 'El precio no es válido';
            }
        }

        return errors;
    };

    const formik = useFormik({ initialValues, validate: validateForm });
    const { isFormFieldInvalid, getFormErrorMessage } = useFormikHelpers(formik);
    const quoterFormik = useRef(null);

    const onQuoterDataChange = (newQuoterFormik) => {
        quoterFormik.current = newQuoterFormik;
        // formik.setFieldValue('random', Math.random());
        sendProductData();
    };

    const consolidateData = () => {
        if (formik.values.selectedProduct && formik.values.selectedProduct.codigo_producto === 'CREMA' && quoterFormik.current) {
            formik.values = { ...formik.values, ...quoterFormik.current.values };
        }

        const errors = validateForm(formik.values);
        formik.setErrors(errors);
    };

    const sendProductData = () => {
        consolidateData();
        onDataChange(formik);
    };

    const onDniSearchClick = () => {
        completePatientData(formik.values.dni);
    };

    const completePatientData = (dni) => {
        if (dni) {
            setSearchingDni(true);
            axios
                .get('/personas/rut/' + dni)
                .then((response) => {
                    if (response.status === 200) {
                        formik.setFieldValue('fullName', response.data.nombre);
                    }
                })
                .catch(() => {
                    toast.current.clear();
                    toast.current.show({ severity: 'warn', detail: 'No se encontró información asociada al Rut' });
                })
                .finally(() => {
                    setSearchingDni(false);
                });
        }
    };

    /* Se pone en modo "validación" */
    useEffect(() => {
        if (validating) {
            formik.submitForm();
        }
    }, [validating]);

    /* Cálculo de precio sin descuento */
    useEffect(() => {
        if (formik.values.selectedVolume) {
            formik.setFieldValue('priceBeforeDiscount', formik.values.selectedVolume.precio * formik.values.quantity);
        } else {
            formik.setFieldValue('priceBeforeDiscount', 0);
        }
    }, [formik.values.selectedVolume, formik.values.quantity]);

    /* Calculo de descuento y precio total */
    useEffect(() => {
        calculateDiscountAndPrice();
    }, [formik.values.priceBeforeDiscount, formik.values.discountPercentage]);

    useEffect(() => {
        sendProductData();
    }, [formik]);

    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            <div className="diagnostic-product row">
                <div className="col-12 col-lg-7">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row gy-4">
                            <div className="col-12 col-lg-6">
                                <label htmlFor="selectedProduct">Producto:</label>
                                <div
                                    className={classNames('p-inputgroup', 'flex-1', 'form-component', {
                                        'p-invalid': isFormFieldInvalid('selectedProduct'),
                                    })}
                                >
                                    <Dropdown
                                        name="selectedProduct"
                                        /* className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('selectedProduct') })} */
                                        value={formik.values.selectedProduct}
                                        inputId="producto"
                                        onChange={onProductChange}
                                        options={products}
                                        optionLabel="producto"
                                        placeholder="Seleccione un producto"
                                        disabled={quotation.estado === 'Pagado'}
                                    />
                                    <Button
                                        type="button"
                                        icon="bi bi-plus"
                                        className="h-100"
                                        onClick={() => {
                                            handleOpenModal();
                                            setFromProduct(true);
                                        }}
                                    />
                                </div>
                                {getFormErrorMessage('selectedProduct')}
                            </div>

                            {formik.values.selectedProduct && formik.values.selectedProduct.codigo_producto === 'CREMA' ? (
                                <div className="col-12">
                                    <CreamsQuoter
                                        product={product}
                                        validating={validating}
                                        onDataChange={onQuoterDataChange}
                                        disabled={quotation.estado === 'Pagado'}
                                    />
                                </div>
                            ) : (
                                <>
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="selectedConcentration">Concentración:</label>
                                        <div
                                            className={classNames('p-inputgroup', 'flex-1', 'form-component', {
                                                'p-invalid': isFormFieldInvalid('selectedConcentration'),
                                            })}
                                        >
                                            <Dropdown
                                                name="selectedConcentration"
                                                value={formik.values.selectedConcentration}
                                                onChange={onConcentrationChange}
                                                options={concentrations}
                                                optionLabel="label"
                                                placeholder="Seleccione una concentración"
                                                emptyMessage="Seleccione un producto para listar sus concentraciones"
                                                disabled={quotation.estado === 'Pagado'}
                                            />
                                            <Button
                                                type="button"
                                                icon="bi bi-plus"
                                                className="h-100"
                                                onClick={() => {
                                                    handleOpenModal();
                                                    setFromProduct(false);
                                                }}
                                            />
                                            {/* 
                                            <a href={appRoot + '/concentraciones'}>
                                                <Button type="button" icon="bi bi-plus" className="h-100" />
                                            </a>
                                            */}
                                        </div>
                                        {getFormErrorMessage('selectedConcentration')}
                                    </div>
                                    <AddConcentrationModal
                                        visible={isModalVisible}
                                        onHide={handleCloseModal}
                                        products={products}
                                        loadProducts={loadProducts}
                                        loadConcentrations={loadConcentrations}
                                        fromProduct={fromProduct}
                                        selectedProduct={formik.values.selectedProduct}
                                        /* onProductChange={onProductChange} */
                                    />
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="selectedVolume">Volumen:</label>
                                        <Dropdown
                                            name="selectedVolume"
                                            className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('selectedVolume') })}
                                            value={formik.values.selectedVolume}
                                            onChange={onVolumeChange}
                                            options={volumes}
                                            optionLabel="label"
                                            placeholder="Seleccione un volumen"
                                            emptyMessage="Seleccione una concentración para listar sus volúmenes"
                                            disabled={quotation.estado === 'Pagado'}
                                        />
                                        {getFormErrorMessage('selectedVolume')}
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="flavor">Sabor:</label>
                                        <Dropdown
                                            name="flavor"
                                            value={formik.values.flavor}
                                            onChange={onFlavorChange}
                                            className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('flavor') })}
                                            options={FLAVORS}
                                            placeholder="Seleccione sabor"
                                            disabled={quotation.estado === 'Pagado'}
                                        />
                                        {getFormErrorMessage('flavor')}
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="quantity">Cantidad:</label>
                                        <div className="form-component">
                                            <InputNumber
                                                name="quantity"
                                                className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('quantity') })}
                                                value={formik.values.quantity}
                                                locale="es-CL"
                                                min={0}
                                                onValueChange={onQuantityChange}
                                                showButtons
                                                disabled={quotation.estado === 'Pagado'}
                                            />
                                        </div>
                                        {getFormErrorMessage('quantity')}
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="priceBeforeDiscount">Precio total:</label>
                                        <div
                                            className={classNames('p-inputgroup', 'flex-1', 'form-component', {
                                                'p-invalid': isFormFieldInvalid('priceBeforeDiscount'),
                                            })}
                                        >
                                            <span className="p-inputgroup-addon">$</span>
                                            <InputNumber
                                                name="priceBeforeDiscount"
                                                value={formik.values.priceBeforeDiscount}
                                                onValueChange={onPriceBeforeDiscountChange}
                                                locale="es-CL"
                                                min={0}
                                                placeholder="Precio"
                                                disabled={quotation.estado === 'Pagado'}
                                            />
                                        </div>
                                        {getFormErrorMessage('priceBeforeDiscount')}
                                    </div>
                                    <div className="col-12">
                                        <label>Descuento (%):</label>
                                        <div className="d-md-flex justify-content-between">
                                            <div className="d-flex justify-content-between flex-grow-1">
                                                <div className="d-flex align-items-center">
                                                    <RadioButton
                                                        inputId="porcDescuento0"
                                                        name="porcDescuento"
                                                        value={0}
                                                        checked={formik.values.discountPercentage === 0}
                                                        onChange={onDiscountPercentageChange}
                                                        disabled={quotation.estado === 'Pagado'}
                                                    />
                                                    <label htmlFor="porcDescuento0" className="ms-2">
                                                        0%
                                                    </label>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <RadioButton
                                                        inputId="porcDescuento10"
                                                        name="porcDescuento"
                                                        value={10}
                                                        checked={formik.values.discountPercentage === 10}
                                                        onChange={onDiscountPercentageChange}
                                                        disabled={quotation.estado === 'Pagado'}
                                                    />
                                                    <label htmlFor="porcDescuento10" className="ms-2">
                                                        10%
                                                    </label>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <RadioButton
                                                        inputId="porcDescuento15"
                                                        name="porcDescuento"
                                                        value={15}
                                                        checked={formik.values.discountPercentage === 15}
                                                        onChange={onDiscountPercentageChange}
                                                        disabled={quotation.estado === 'Pagado'}
                                                    />
                                                    <label htmlFor="porcDescuento15" className="ms-2">
                                                        15%
                                                    </label>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <RadioButton
                                                        inputId="porcDescuento20"
                                                        name="porcDescuento"
                                                        value={20}
                                                        checked={formik.values.discountPercentage === 20}
                                                        onChange={onDiscountPercentageChange}
                                                        disabled={quotation.estado === 'Pagado'}
                                                    />
                                                    <label htmlFor="porcDescuento20" className="ms-2">
                                                        20%
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="ps-md-4 d-flex align-items-center">
                                                <label htmlFor="porcDescuentoOtro" className="ms-2">
                                                    Otro:
                                                </label>
                                                <div className="form-component">
                                                    <InputNumber
                                                        name="porcDescuentoOtro"
                                                        className="form-component w-auto ms-2 porc-descuento-otro"
                                                        value={formik.values.discountPercentage}
                                                        locale="es-CL"
                                                        min={0}
                                                        max={99}
                                                        onValueChange={onDiscountPercentageChange}
                                                        showButtons
                                                        disabled={quotation.estado === 'Pagado'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="discountValue">Descuento:</label>
                                        <div
                                            className={classNames('p-inputgroup', 'flex-1', 'form-component', {
                                                'p-invalid': isFormFieldInvalid('discountValue'),
                                            })}
                                        >
                                            <span className="p-inputgroup-addon">$</span>
                                            <InputNumber
                                                name="discountValue"
                                                value={formik.values.discountValue}
                                                locale="es-CL"
                                                min={0}
                                                readOnly
                                                disabled={quotation.estado === 'Pagado'}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <label htmlFor="totalPrice">Precio total con descuento:</label>
                                        <div
                                            className={classNames('p-inputgroup', 'flex-1', 'form-component', {
                                                'p-invalid': isFormFieldInvalid('totalPrice'),
                                            })}
                                        >
                                            <span className="p-inputgroup-addon">$</span>
                                            <InputNumber
                                                name="totalPrice"
                                                value={formik.values.totalPrice}
                                                locale="es-CL"
                                                min={0}
                                                readOnly
                                                disabled={quotation.estado === 'Pagado'}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="col-12 col-lg-6">
                                <label htmlFor="dni">Rut del titular:</label>
                                <div className="include-search-button">
                                    <InputRut
                                        name="dni"
                                        disabled={quotation.estado === 'Pagado'}
                                        value={formik.values.dni}
                                        onChange={onDniChange}
                                        className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('dni') })}
                                    />
                                    <Button
                                        severity="secondary"
                                        icon="bi bi-search"
                                        type="button"
                                        disabled={quotation.estado === 'Pagado'}
                                        onClick={onDniSearchClick}
                                        loading={searchingDni}
                                    />
                                </div>
                                {getFormErrorMessage('dni')}
                            </div>
                            <div className="col-12 col-lg-6">
                                <label htmlFor="fullName">Nombre del titular:</label>
                                <InputText
                                    name="fullName"
                                    value={formik.values.fullName}
                                    onChange={onFullNameChange}
                                    maxLength={100}
                                    disabled={quotation.estado === 'Pagado'}
                                    className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('fullName') })}
                                />
                                {getFormErrorMessage('fullName')}
                            </div>
                            <div className="col-12 col-lg-6">
                                <label htmlFor="medicalCheckDate">Fecha del control médico:</label>
                                <Calendar
                                    name="medicalCheckDate"
                                    className={classNames('form-component')}
                                    value={formik.values.medicalCheckDate}
                                    onChange={onMedicalCheckDateChange}
                                    dateFormat="mm/yy"
                                    showButtonBar
                                    view="month"
                                    locale="es"
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <label htmlFor="expirationDate">Fecha de expiración de la receta:</label>
                                <Calendar
                                    name="expirationDate"
                                    className={classNames('form-component')}
                                    value={formik.values.expirationDate}
                                    onChange={onExpirationDateChange}
                                    dateFormat="dd/mm/yy"
                                    showButtonBar
                                    locale="es"
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <label htmlFor="renovationDate">Fecha de renovación del tratamiento:</label>
                                <Calendar
                                    name="renovationDate"
                                    className={classNames('form-component')}
                                    value={formik.values.renovationDate}
                                    onChange={onRenovationDateChange}
                                    dateFormat="dd/mm/yy"
                                    showButtonBar
                                    locale="es"
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <label htmlFor="ticketNumbers">Números de boleta (Enter después de cada número):</label>
                                <Chips
                                    name="ticketNumbers"
                                    className={classNames('form-component', { 'p-invalid': isFormFieldInvalid('ticketNumbers') })}
                                    value={formik.values.ticketNumbers}
                                    onChange={onTicketNumbersChange}
                                    keyfilter="int"
                                    allowDuplicate={false}
                                />
                                {getFormErrorMessage('ticketNumbers')}
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-12 col-lg-5 prescription">
                    <label>Receta:</label>
                    <DrawPrescription visible={true} product={product} quotation={quotation} productsLen={productsLen} />
                </div>
            </div>
        </>
    );
};

export default memo(DiagnosticProduct);
// export default DiagnosticProduct;
